export interface VehicleBodyType {
    id: number;
    name: string;
    displayName?: string;
}

export const VEHICLE_BODY_TYPES: VehicleBodyType[] = [
    { id: 0, name: "Unknown" },
    { id: 1, name: "TwoWayTipper" },
    { id: 2, name: "ThreeWayTipper" },
    { id: 3, name: "RollOffContainer" },
    { id: 4, name: "RollOffHookLifter" },
    { id: 5, name: "EjectorSystem" },
    { id: 6, name: "SkipLoader" },
    { id: 7, name: "AluminumBoxBody" },
    { id: 8, name: "Ambulance" },
    { id: 9, name: "AerialWorkPlatform" },
    { id: 10, name: "AtvQuadUtv" },
    { id: 11, name: "BodyForRollOffContainer" },
    { id: 12, name: "CarTransporter" },
    { id: 13, name: "ConstructionMachineryTrailer" },
    { id: 14, name: "AccessibleVehicle" },
    { id: 15, name: "ConcreteMixer" },
    { id: 16, name: "ConcretePump" },
    { id: 17, name: "ConcreteSilo" },
    { id: 18, name: "BoatTrailer" },
    { id: 19, name: "CurtainSider" },
    { id: 20, name: "Flatbed" },
    { id: 21, name: "ChassisCab" },
    { id: 22, name: "Container" },
    { id: 23, name: "SpareParts" },
    { id: 24, name: "FireService" },
    { id: 25, name: "SUV" },
    { id: 26, name: "BeverageBody" },
    { id: 27, name: "TimberTransport" },
    { id: 28, name: "PanelVan" },
    { id: 29, name: "RefuseTruck" },
    { id: 30, name: "Sweeper" },
    { id: 31, name: "TrackedVehicle" },
    { id: 32, name: "MunicipalTractor" },
    { id: 33, name: "MunicipalTransporter" },
    { id: 34, name: "MunicipalService" },
    { id: 35, name: "Crane" },
    { id: 36, name: "PlasticBoxBody" },
    { id: 37, name: "InsulatedPlasticBoxBody" },
    { id: 38, name: "RefrigeratedContainer" },
    { id: 39, name: "RefrigeratedVehicle" },
    { id: 40, name: "CityBus" },
    { id: 41, name: "BulkCargoBody" },
    { id: 42, name: "MiniBus" },
    { id: 43, name: "MiniVan" },
    { id: 44, name: "Snowmobile" },
    { id: 45, name: "HorseTransporter" },
    { id: 46, name: "PharmaVehicle" },
    { id: 47, name: "Pickup" },
    { id: 48, name: "PickupWithOriginalBed" },
    { id: 49, name: "Groomer" },
    { id: 50, name: "Platform" },
    { id: 51, name: "PlywoodBox" },
    { id: 52, name: "Coach" },
    { id: 53, name: "RearTipper" },
    { id: 54, name: "FifthWheel" },
    { id: 55, name: "VacuumTruck" },
    { id: 56, name: "SlidingCurtain" },
    { id: 57, name: "WalkingFloor" },
    { id: 58, name: "CableSystem" },
    { id: 59, name: "Silo" },
    { id: 60, name: "SpecialPurposeBody" },
    { id: 61, name: "SportsEquipmentTrailer" },
    { id: 62, name: "TankBody" },
    { id: 63, name: "ThermalSilo" },
    { id: 64, name: "LowLoader" },
    { id: 65, name: "SanitationVehicle" },
    { id: 66, name: "SalesVehicle" },
    { id: 67, name: "LivestockBody" },
    { id: 68, name: "SwapBody" },
    { id: 69, name: "SwapFrame" },
    { id: 70, name: "SwapSystem" },
    { id: 71, name: "WinterService" },
    { id: 72, name: "Motorhome" },
    { id: 73, name: "Accessories" },
    { id: 74, name: "Roller" }
];